import axios from "axios";

import Utils from "@teamprevent/common/utils";

import {
    SNCRuleDetailModel,
    SNCRuleListModel } from "./models";
import { SNCRuleFormModel } from "./schema";

const apiUrl = "/api/sncRules";

const getAll = async (): Promise<SNCRuleListModel[]> => {
    const response = await axios.get<SNCRuleListModel[]>(apiUrl);
    return response.data;
};

const get = async (id: string): Promise<SNCRuleDetailModel> => {
    const response = await axios.get<SNCRuleDetailModel>(`${apiUrl}/${id}`);
    return parseDetailModel(response.data);
};

const create = async (sncRuleModel: SNCRuleFormModel): Promise<SNCRuleListModel | null> => {
    const response = await axios.post(`${apiUrl}`, parseCreateEditModel(sncRuleModel));

    const result = Utils.CheckResponse<SNCRuleListModel>(response.data);

    if (!result)
    {
        return null;
    }

    return result;
};

const update = async (sncRuleModel: SNCRuleFormModel): Promise<SNCRuleDetailModel | null> => {
    const response = await axios.put(`${apiUrl}/${sncRuleModel.id}`, parseCreateEditModel(sncRuleModel));

    const result = Utils.CheckResponse<SNCRuleDetailModel>(response.data);

    if (!result)
    {
        return null;
    }

    return parseDetailModel(result);
};

const parseCreateEditModel = (sncRuleModel: SNCRuleFormModel): SNCRuleFormModel => {
    sncRuleModel.sncPeriodOne.chargeablePercentage = sncRuleModel.sncPeriodOne.chargeablePercentage / 100;

    if (sncRuleModel.sncPeriodTwo.chargeablePercentage !== null) {
        sncRuleModel.sncPeriodTwo.chargeablePercentage = sncRuleModel.sncPeriodTwo.chargeablePercentage / 100;
    }

    return sncRuleModel;
};

const parseDetailModel = (sncRuleModel: SNCRuleDetailModel): SNCRuleDetailModel => {
    sncRuleModel.sncPeriodOne.chargeablePercentage = Math.floor(sncRuleModel.sncPeriodOne.chargeablePercentage! * 100);

    if (sncRuleModel.sncPeriodTwo.chargeablePercentage !== null) {
        sncRuleModel.sncPeriodTwo.chargeablePercentage = Math.floor(sncRuleModel.sncPeriodTwo.chargeablePercentage * 100);
    }

    return sncRuleModel;
};

export const SNCRulesApi = { getAll, get, create, update };
